import { render } from "./index.vue?vue&type=template&id=4b9874d7"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4b9874d7&lang=scss"

import exportComponent from "/Users/shuaqq/Desktop/quickadmin/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__